import { type GetServerSidePropsContext } from 'next';

import { IMPERSONATED_USER_KEY } from './impersonation';

export const constructServerSideRenderingContext = (
  req: GetServerSidePropsContext['req'],
  resolvedUrl: string,
) => {
  const impersonatedUserId = req.cookies[IMPERSONATED_USER_KEY];
  return {
    headers: {
      cookie: req.headers.cookie, // pass all cookies to backend
      referer:
        req.headers.referer ?? `https://${req.headers.host}${resolvedUrl}`,
      ...(impersonatedUserId
        ? { [IMPERSONATED_USER_KEY]: impersonatedUserId }
        : {}),
    },
  };
};
